import { HardwareModels } from "types/productTypes";
import { errorMessage } from "@utils/errorMessage";
import {
  detectHardwareModel,
  enableDpvrKioskMode,
  grantPermissions,
  provisionApiKeyConfig,
  pushConfig,
  pushConfig1,
  rebootDevice,
} from "./ADBUtils";
import { pushesPicoLauncherConfig, pushesPicoSeethroughConfig } from "./headsetSetupSteps";

export interface PushDeviceConfigsResult {
  apiConfigPushFailed: boolean;
}

export async function pushDeviceConfigsAndReboot(
  apiConfigKey: string | null,
  log: (msg: string) => void,
  onBeforeReboot?: () => void,
): Promise<PushDeviceConfigsResult> {
  let apiConfigPushFailed = false;
  const model = await detectHardwareModel();
  if (pushesPicoLauncherConfig(model)) {
    log("Pushing config (config.txt) ...");
    await pushConfig(log);
  }
  if (pushesPicoSeethroughConfig(model)) {
    log("Pushing Config1 (Config1.txt) ...");
    await pushConfig1(log);
  }
  log("Granting permissions ...");
  await grantPermissions(log);
  if (model === HardwareModels.Dpvr) {
    log("Enabling kiosk mode ...");
    await enableDpvrKioskMode(log);
  }
  if (apiConfigKey !== null) {
    log(`Pushing API key configuration (${apiConfigKey}) ...`);
    try {
      await provisionApiKeyConfig(apiConfigKey, log);
    } catch (error) {
      apiConfigPushFailed = true;
      log("API key configuration push failed: " + errorMessage(error));
    }
  }
  log("Rebooting device ...");
  onBeforeReboot?.();
  await rebootDevice(log);
  return { apiConfigPushFailed };
}
